import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
// import { PortType, Housing, SME, Corporate } from '../pages/master/master-constant';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor( 
    private router:Router,
    private http: HttpClient,
  ) { }

  private KEY             = "GG";
  private KEY_PF          = "PORTS";
  private KEY_PF_RAW      = "PF";
  private KEY_ACC_INIT    = "ACC_INIT";
  private KEY_SME_BY_BANK = "SME_BY_BANK";
  private ggData    : any;
  private pfData    : any;
  private pfByBanks : any;

  private userRoles = {};
  private userRolesDesc = {};

  roleAdmin = "ADM";
  roleAcc   = "ACC";
  roleAm    = "AM";
  roleAmm   = "AMM";
  roleCeo   = "CEO";
  roleCfo   = "CFO";
  roleFin   = "FIN";
  roleLg    = "LG"; 
  roleOpr   = "OPR";

  isADM   = false;
  isCEO   = false;
  isCFO   = false;
  isACC_M = false;
  isACC   = false;
  isAM_M  = false;
  isAM    = false;
  isFIN_M = false;
  isFIN   = false;
  isLG_M  = false;
  isLG    = false;
  isOPR_M = false;
  isOPR   = false;

  portHousing    = "Housing";
  portSME        = "SME";
  portCorporate  = "Corporate";

  getProfile(){
    return this.getLSGG();  
  }
  getPortfolio(){
    return this.getLSPF();  
  }
  getPortfolioRaw(){
    return this.getLSPF_RAW();  
  }
  getPortHousing( rptDate?: Date ){
    if( rptDate ){
      return this.getLSPF( rptDate )[ this.portHousing ];  
    }else{
      return this.getLSPF()[ this.portHousing ];  
    }
  }
  getPortSME( rptDate?: Date ){
    if( rptDate ){
      return this.getLSPF( rptDate )[ this.portSME ];  
    }else{
      return this.getLSPF()[ this.portSME ];  
    } 
  }
  getPortCorporate( rptDate?: Date ){
    if( rptDate ){
      return this.getLSPF( rptDate )[ this.portCorporate ];  
    }else{
      return this.getLSPF()[ this.portCorporate ];  
    }
  }

  getRoleDescrition(role){
    return this.userRolesDesc[role];
  }

  setProfile(data){
    if( this.setLSGG(data) ){
      // this.router.navigate(['/']);
    }
  }
  
  setKCCProfile(data){
    
  }

  removeProfile(){
    this.removeLSGG();
    if( this.ggData ){
      this.genAccessLog( this.ggData, 3 );
    }
  }

  setPort( data ){
    if( this.setLSPF( data ) ){
      this.router.navigate(['/']);
    }
  }

  setNewDebtors( newDebtors ){
    
    var uniqueDt = {};

    for( var pt in newDebtors ){

      var debtors  = newDebtors[ pt ];

      for( var dt in debtors ){

        var kccId = debtors[ dt ][ "KCC_DT_ID" ];

        if( uniqueDt[ kccId ] ){

          uniqueDt[ kccId ][ "INV_START" ] += debtors[ dt ][ "DT_INV" ];

        }else{

          var newDebtor = {
            "PORT"      : debtors[ dt ][ "PF_CODE"   ],
            "KCC_ID"    : debtors[ dt ][ "KCC_DT_ID" ],
            "BANK_ID"   : debtors[ dt ][ "DT_BANK_ACC" ],
            "INV_START" : debtors[ dt ][ "DT_INV" ],
            "CUT"       : 0,
            "LAST_INT"  : 0,
            "TRAN_DATE" : new Date( debtors[ dt ][ "DT_TRAN_DATE" ] ),
            "SIGN_DATE" : new Date( debtors[ dt ][ "DT_SIGN_DATE" ] )
          }
          uniqueDt[ debtors[ dt ][ "KCC_DT_ID" ] ] = newDebtor;
        }
        
      }
    }
    localStorage.setItem( this.KEY_ACC_INIT, JSON.stringify({ACC_INIT: uniqueDt}) );
  }
  
  removePort(){
    this.removeLSPF();
  }
  
//-- ---------------------------------------------------------------------------------------

  getLSGG() {
    try {
      const raw = localStorage.getItem(this.KEY);
      if (!raw) throw new Error("No GG in localStorage");

      const parsed = JSON.parse(raw);
      if (!parsed[this.KEY]) throw new Error("No GG object inside");

      this.ggData = parsed[this.KEY];
      return this.ggData;
    } catch (error) {
      this.removeLSGG();
      this.router.navigate(['/login']);
      return null;
    }
  }

  private removeLSGG(){
    localStorage.removeItem(this.KEY);
  }

  private setLSGG(data){
    let lb_success = true;
    try {
     
      localStorage.setItem( this.KEY, JSON.stringify({GG: data}) );
   
    } catch (error) {
      lb_success = false;
    }
    return lb_success;
  }
  //-- ---------------------------------------------------------------------------------------
  //-- ---------------------------------------------------------------------------------------
  getLSPF( rptDate?: Date ) {
    let lsItem = JSON.parse(localStorage.getItem( this.KEY_PF ));
    var ports  = {};
    try {

      this.pfData = lsItem[ this.KEY_PF ];


      if( rptDate ){
        
        var prtHS   = lsItem[ this.KEY_PF ][ this.portHousing   ];
        var prtSME  = lsItem[ this.KEY_PF ][ this.portSME       ];
        var prtCORP = lsItem[ this.KEY_PF ][ this.portCorporate ];
        ports[ this.portHousing   ] = [];
        ports[ this.portSME       ] = [];
        ports[ this.portCorporate ] = [];
        //-- HOUSING
        for( var len1 = 0 ; len1 < prtHS.length ; len1++ ){
          var setPort = true;
          for( var x in lsItem[ this.KEY_PF_RAW ] ){
            if( lsItem[ this.KEY_PF_RAW ][ x ][ "PF_CODE" ] == prtHS[ len1 ] ){
              //-- check sign date
              var signDate     = new Date ( lsItem[ this.KEY_PF_RAW ][ x ][ "PF_BUY_DATE" ] );
              if( signDate > rptDate ){
                // console.log("IN getLSPF pass ", prtHS[ len1 ]);
                setPort = false;
              }
              break;
            }
          }
          if( setPort ){
            ports[ this.portHousing ].push( prtHS[ len1 ] );
          }
        }
        //-- SME
        for( var len2 = 0 ; len2 < prtSME.length ; len2++ ){
          var setPort = true;
          for( var y in lsItem[ this.KEY_PF_RAW ] ){
            if( lsItem[ this.KEY_PF_RAW ][ y ][ "PF_CODE" ] == prtSME[ len2 ] ){
              //-- check sign date
              var signDate     = new Date ( lsItem[ this.KEY_PF_RAW ][ y ][ "PF_BUY_DATE" ] );
              if( signDate > rptDate ){
                // console.log("IN getLSPF pass ", prtSME[ len2 ]);
                setPort = false;
              }
              break;
            }
          }
          if( setPort ){
            ports[ this.portSME ].push( prtSME[ len2 ] );
          }
        }
        //-- CORP
        for( var len3 = 0 ; len3 < prtCORP.length ; len3++ ){
          var setPort = true;
          for( var z in lsItem[ this.KEY_PF_RAW ] ){
            if( lsItem[ this.KEY_PF_RAW ][ z ][ "PF_CODE" ] == prtCORP[ len3 ] ){
              //-- check sign date
              var signDate     = new Date ( lsItem[ this.KEY_PF_RAW ][ z ][ "PF_BUY_DATE" ] );
              if( signDate > rptDate ){
                // console.log("IN getLSPF pass ", prtCORP[ len3 ]);
                setPort = false;
              }
              break;
            }
          }
          if( setPort ){
            ports[ this.portCorporate ].push( prtCORP[ len3 ] );
          }
        }
        
        
      }else{
        ports = this.pfData;
      }

    } catch (error) {
      //console.log("getLSGG : " + error);
      this.router.navigate(['/login']);
    }

    return ports;
  }
  //-- ---------------------------------------------------------------------------------------
  getLSPF_RAW() {
    let lsItem = JSON.parse(localStorage.getItem( this.KEY_PF_RAW ));
    try {
      this.pfData = lsItem[ this.KEY_PF_RAW ];

    } catch (error) {
      
      this.router.navigate(['/login']);
    }

    return this.pfData;
  }
  //-- ---------------------------------------------------------------------------------------//-- ------------------------------------------------------------------------
  //-- 26/09/2566
  //-- get Housing group by bank
  getSMEbyBank(  ) {
    let lsItem = JSON.parse(localStorage.getItem( this.KEY_SME_BY_BANK ));
    try {
      this.pfByBanks = lsItem[ this.KEY_SME_BY_BANK ];
    } catch (error) {
      this.router.navigate(['/login']);
    }
    return this.pfByBanks;
  }
  //-- ---------------------------------------------------------------------------------------
  getACC_INIT() {
    let lsItem = JSON.parse(localStorage.getItem( this.KEY_ACC_INIT ));
    var accInitData;
    try {

      accInitData = lsItem[ this.KEY_ACC_INIT ];

    } catch (error) {
      
      this.router.navigate(['/login']);
    }
    return accInitData;
  }
  //-- ---------------------------------------------------------------------------------------
  private removeLSPF(){
    localStorage.removeItem( this.KEY_PF     );
    localStorage.removeItem( this.KEY_PF_RAW );
  }

  private setLSPF( data ){
    let lb_success = true;
    try {
     
      localStorage.setItem( this.KEY_PF_RAW, JSON.stringify({PF: data}) );

      var pfCodes = {};
        
      var hsPort01 = "SCB-HS1";
      var hsPort02 = "SCB-HS2";
      var hsPort03 = "TMB-HS3";
      var hsPort04 = "SCB-HS4";
      var hsPort05 = "SCB-HS5";
        
      var smePort01 = "ICBC-SME1";
      var smePort02 = "SAM-SME1";
      var smePort03 = "SAM-SME2";
      var smePort04 = "SAM-SME3";
      var smePort05 = "SCBT-SME1";
      var smePort06 = "SCBT-SME2";
      var smePort07 = "TMB-SME1";
      var smePort08 = "OCBC-SME1";
      var smePort09 = "BAM-SME1";
      var smePort10 = "CIMB-SME1";

      var corpPort01 = "SAM-CORP1";
      var corpPort02 = "SCBT-CORP1";
      var corpPort03 = "SCBT-CORP2";
      var corpPort04 = "SCBT-CORP3";

      pfCodes[ this.portHousing   ] = [];
      pfCodes[ this.portSME       ] = [];
      pfCodes[ this.portCorporate ] = [];

      
      pfCodes[ this.portHousing ].push( hsPort01 );
      pfCodes[ this.portHousing ].push( hsPort02 );
      pfCodes[ this.portHousing ].push( hsPort03 );
      pfCodes[ this.portHousing ].push( hsPort04 );
      pfCodes[ this.portHousing ].push( hsPort05 );
      
      pfCodes[ this.portSME ].push( smePort01 );
      pfCodes[ this.portSME ].push( smePort02 );
      pfCodes[ this.portSME ].push( smePort03 );
      pfCodes[ this.portSME ].push( smePort04 );
      pfCodes[ this.portSME ].push( smePort05 );
      pfCodes[ this.portSME ].push( smePort06 );
      pfCodes[ this.portSME ].push( smePort07 );
      pfCodes[ this.portSME ].push( smePort08 );
      pfCodes[ this.portSME ].push( smePort09 );
      pfCodes[ this.portSME ].push( smePort10 );
      
      pfCodes[ this.portCorporate ].push( corpPort01 );
      pfCodes[ this.portCorporate ].push( corpPort02 );
      pfCodes[ this.portCorporate ].push( corpPort03 );
      pfCodes[ this.portCorporate ].push( corpPort04 );

      for( var x in data ){
        if( pfCodes[ data[ x ]["PF_TYPE"] ] == null ){
          pfCodes[ data[ x ]["PF_TYPE"] ] = [];
        }
        pfCodes[ data[ x ]["PF_TYPE"] ].push( data[ x ]["PF_CODE"] );
      }
      localStorage.setItem( this.KEY_PF, JSON.stringify({PORTS: pfCodes}) );

      //-- ------------------------------------------------------------------------
      //-- 26/09/2566
      //-- get Housing group by bank
      var smePort       = pfCodes[ this.portSME ];
      var bankIds       = [];
      var smePortByBank = {};
      for( var a in smePort ){
        bankIds.push( smePort[ a ].split( "-" )[ 0 ] );
      }
      bankIds.sort();
      for( var b in bankIds ){
        var bankId = bankIds[ b ];
        if( smePortByBank[ bankId ]){
          continue;
        }else{
          smePortByBank[ bankId ] = [];
        }
      }
      for( var c in smePort ){
        smePortByBank[ smePort[ c ].split( "-" )[ 0 ] ].push( smePort[ c ] );
      }
      localStorage.setItem( this.KEY_SME_BY_BANK, JSON.stringify({SME_BY_BANK: smePortByBank}) );
      //-- ------------------------------------------------------------------------

   
    } catch (error) {
      lb_success = false;
    }
    return lb_success;
  }
//-- ---------------------------------------------------------------------------------------

  numberWithCommas( x ){
    var value = x * 100;
        value = Math.round(value);
        value /= 100;
    var parts = value.toString().split(".");
    parts[0]  = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  
  numberWithCommasDecial( x, decimal ){
    var value = x * 100;
        value = Math.round(value);
        value /= 100;

    var sValue = value.toFixed(decimal);
    var parts  = sValue.split(".");


    parts[0]  = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  
  genAccessLog( res, option ) {
    //-- option
    //-- 1 : loged in
    //-- 2 : access dashboard
    //-- 3 : loged out

    var msg = res["U_EMAIL"];

    if( option == 1 ){
      msg += " logged in successfully.";
    }else if( option == 2 ){
      msg += " accessed dashboard.";
    }else if( option == 3 ){
      msg += " logged out successfully.";
    }

    //-- note
    var log = {};
    log["U_SYS_ID"] = res["_id"];
    log["U_EMAIL"]  = res["U_EMAIL"];
    log["U_LOG"]    = msg;

    log["CRT_USER"]  = "SYSTEM";
    log["UPD_USER"]  = log["CRT_USER"];
    this.http.post('/logaccess', log)
      .subscribe(res => {

        
        }, (err) => {
          console.log(err);
        }
    );
  }

  isLoggedIn(): boolean {
    const profile = this.getProfile();
    return !!(profile && profile["email"]);
  }

}

